export enum DATE_TIME_FORMATS {
  DDMMYY = 'DD/MM/YY',
  DDMMYYYY = 'DD/MM/YYYY',
  MMDDYYYY = 'MM/DD/YYYY',
  TIME_12H = 'hh:mm A',
  TIME_12H_SECONDS = 'hh:mm:ss A',
  TIME_24H = 'HH:mm',
  TIME_24H_SECONDS = 'HH:mm:ss'
}

export enum LOCALES {
  ENGLISH = 'en',
  ENGLISH_GB = 'en-GB',
  ENGLISH_US = 'en-US',
  FRENCH = 'fr',
  FRENCH_FRANCE = 'fr-FR',
  GERMAN = 'de',
  GERMAN_GERMANY = 'de-DE',
  ITALIAN = 'it',
  ITALIAN_ITALY = 'it-IT',
  SPANISH = 'es',
  SPANISH_SPAIN = 'es-ES',
  BULGARIAN = 'bg',
  CZECH = 'cs',
  GREEK = 'el',
  LITHUANIAN = 'lt',
  POLISH = 'pl',
  PORTUGUESE = 'pt',
  PORTUGUESE_PORTUGAL = 'pt-PT',
  ROMANIAN = 'ro',
  ROMANIAN_ROMANIA = 'ro-RO',
  CROATIAN = 'hr',
  SLOVAK = 'sk',
  SLOVENIAN = 'sl',
  TURKISH = 'tr',
  MACEDONIAN = 'mk',
  ESTONIAN = 'et',
  NORWEGIAN = 'no',
  DUTCH = 'nl'
}

export enum DISTANCE_UNITS {
  IMPERIAL = 'imperial',
  METRIC = 'metric'
}

export const l10n = {
  [LOCALES.ENGLISH]: {
    dateFormat: DATE_TIME_FORMATS.DDMMYY,
    distanceUnits: DISTANCE_UNITS.METRIC,
    mapTileLg: 'en',
    timeFormat: DATE_TIME_FORMATS.TIME_24H,
    timeFormatWithSeconds: DATE_TIME_FORMATS.TIME_24H_SECONDS
  },
  [LOCALES.ENGLISH_GB]: {
    dateFormat: DATE_TIME_FORMATS.DDMMYY,
    distanceUnits: DISTANCE_UNITS.METRIC,
    mapTileLg: 'en',
    timeFormat: DATE_TIME_FORMATS.TIME_24H,
    timeFormatWithSeconds: DATE_TIME_FORMATS.TIME_24H_SECONDS
  },
  [LOCALES.ENGLISH_US]: {
    dateFormat: DATE_TIME_FORMATS.DDMMYY,
    distanceUnits: DISTANCE_UNITS.IMPERIAL,
    mapTileLg: 'en',
    timeFormat: DATE_TIME_FORMATS.TIME_24H,
    timeFormatWithSeconds: DATE_TIME_FORMATS.TIME_24H_SECONDS
  },
  [LOCALES.FRENCH]: {
    dateFormat: DATE_TIME_FORMATS.DDMMYY,
    distanceUnits: DISTANCE_UNITS.METRIC,
    mapTileLg: 'fr',
    timeFormat: DATE_TIME_FORMATS.TIME_24H,
    timeFormatWithSeconds: DATE_TIME_FORMATS.TIME_24H_SECONDS
  },
  [LOCALES.FRENCH_FRANCE]: {
    dateFormat: DATE_TIME_FORMATS.DDMMYY,
    distanceUnits: DISTANCE_UNITS.METRIC,
    mapTileLg: 'fr',
    timeFormat: DATE_TIME_FORMATS.TIME_24H,
    timeFormatWithSeconds: DATE_TIME_FORMATS.TIME_24H_SECONDS
  },
  [LOCALES.GERMAN]: {
    dateFormat: DATE_TIME_FORMATS.DDMMYY,
    distanceUnits: DISTANCE_UNITS.METRIC,
    mapTileLg: 'de',
    timeFormat: DATE_TIME_FORMATS.TIME_24H,
    timeFormatWithSeconds: DATE_TIME_FORMATS.TIME_24H_SECONDS
  },
  [LOCALES.GERMAN_GERMANY]: {
    dateFormat: DATE_TIME_FORMATS.DDMMYY,
    distanceUnits: DISTANCE_UNITS.METRIC,
    mapTileLg: 'de',
    timeFormat: DATE_TIME_FORMATS.TIME_24H,
    timeFormatWithSeconds: DATE_TIME_FORMATS.TIME_24H_SECONDS
  },
  [LOCALES.ITALIAN]: {
    dateFormat: DATE_TIME_FORMATS.DDMMYY,
    distanceUnits: DISTANCE_UNITS.METRIC,
    mapTileLg: 'it',
    timeFormat: DATE_TIME_FORMATS.TIME_24H,
    timeFormatWithSeconds: DATE_TIME_FORMATS.TIME_24H_SECONDS
  },
  [LOCALES.ITALIAN_ITALY]: {
    dateFormat: DATE_TIME_FORMATS.DDMMYY,
    distanceUnits: DISTANCE_UNITS.METRIC,
    mapTileLg: 'it',
    timeFormat: DATE_TIME_FORMATS.TIME_24H,
    timeFormatWithSeconds: DATE_TIME_FORMATS.TIME_24H_SECONDS
  },
  [LOCALES.SPANISH]: {
    dateFormat: DATE_TIME_FORMATS.DDMMYY,
    distanceUnits: DISTANCE_UNITS.METRIC,
    mapTileLg: 'es',
    timeFormat: DATE_TIME_FORMATS.TIME_24H,
    timeFormatWithSeconds: DATE_TIME_FORMATS.TIME_24H_SECONDS
  },
  [LOCALES.SPANISH_SPAIN]: {
    dateFormat: DATE_TIME_FORMATS.DDMMYY,
    distanceUnits: DISTANCE_UNITS.METRIC,
    mapTileLg: 'es',
    timeFormat: DATE_TIME_FORMATS.TIME_24H,
    timeFormatWithSeconds: DATE_TIME_FORMATS.TIME_24H_SECONDS
  },
  [LOCALES.BULGARIAN]: {
    dateFormat: DATE_TIME_FORMATS.DDMMYY,
    distanceUnits: DISTANCE_UNITS.METRIC,
    mapTileLg: 'bg',
    timeFormat: DATE_TIME_FORMATS.TIME_24H,
    timeFormatWithSeconds: DATE_TIME_FORMATS.TIME_24H_SECONDS
  },
  [LOCALES.CZECH]: {
    dateFormat: DATE_TIME_FORMATS.DDMMYY,
    distanceUnits: DISTANCE_UNITS.METRIC,
    mapTileLg: 'cs',
    timeFormat: DATE_TIME_FORMATS.TIME_24H,
    timeFormatWithSeconds: DATE_TIME_FORMATS.TIME_24H_SECONDS
  },
  [LOCALES.GREEK]: {
    dateFormat: DATE_TIME_FORMATS.DDMMYY,
    distanceUnits: DISTANCE_UNITS.METRIC,
    mapTileLg: 'el',
    timeFormat: DATE_TIME_FORMATS.TIME_24H,
    timeFormatWithSeconds: DATE_TIME_FORMATS.TIME_24H_SECONDS
  },
  [LOCALES.LITHUANIAN]: {
    dateFormat: DATE_TIME_FORMATS.DDMMYY,
    distanceUnits: DISTANCE_UNITS.METRIC,
    mapTileLg: 'lt',
    timeFormat: DATE_TIME_FORMATS.TIME_24H,
    timeFormatWithSeconds: DATE_TIME_FORMATS.TIME_24H_SECONDS
  },
  [LOCALES.POLISH]: {
    dateFormat: DATE_TIME_FORMATS.DDMMYY,
    distanceUnits: DISTANCE_UNITS.METRIC,
    mapTileLg: 'pl',
    timeFormat: DATE_TIME_FORMATS.TIME_24H,
    timeFormatWithSeconds: DATE_TIME_FORMATS.TIME_24H_SECONDS
  },
  [LOCALES.PORTUGUESE]: {
    dateFormat: DATE_TIME_FORMATS.DDMMYY,
    distanceUnits: DISTANCE_UNITS.METRIC,
    mapTileLg: 'pt',
    timeFormat: DATE_TIME_FORMATS.TIME_24H,
    timeFormatWithSeconds: DATE_TIME_FORMATS.TIME_24H_SECONDS
  },
  [LOCALES.PORTUGUESE_PORTUGAL]: {
    dateFormat: DATE_TIME_FORMATS.DDMMYY,
    distanceUnits: DISTANCE_UNITS.METRIC,
    mapTileLg: 'pt',
    timeFormat: DATE_TIME_FORMATS.TIME_24H,
    timeFormatWithSeconds: DATE_TIME_FORMATS.TIME_24H_SECONDS
  },
  [LOCALES.ROMANIAN]: {
    dateFormat: DATE_TIME_FORMATS.DDMMYY,
    distanceUnits: DISTANCE_UNITS.METRIC,
    mapTileLg: 'ro',
    timeFormat: DATE_TIME_FORMATS.TIME_24H,
    timeFormatWithSeconds: DATE_TIME_FORMATS.TIME_24H_SECONDS
  },
  [LOCALES.ROMANIAN_ROMANIA]: {
    dateFormat: DATE_TIME_FORMATS.DDMMYY,
    distanceUnits: DISTANCE_UNITS.METRIC,
    mapTileLg: 'ro',
    timeFormat: DATE_TIME_FORMATS.TIME_24H,
    timeFormatWithSeconds: DATE_TIME_FORMATS.TIME_24H_SECONDS
  },
  [LOCALES.CROATIAN]: {
    dateFormat: DATE_TIME_FORMATS.DDMMYY,
    distanceUnits: DISTANCE_UNITS.METRIC,
    mapTileLg: 'hr',
    timeFormat: DATE_TIME_FORMATS.TIME_24H,
    timeFormatWithSeconds: DATE_TIME_FORMATS.TIME_24H_SECONDS
  },
  [LOCALES.SLOVAK]: {
    dateFormat: DATE_TIME_FORMATS.DDMMYY,
    distanceUnits: DISTANCE_UNITS.METRIC,
    mapTileLg: 'sk',
    timeFormat: DATE_TIME_FORMATS.TIME_24H,
    timeFormatWithSeconds: DATE_TIME_FORMATS.TIME_24H_SECONDS
  },
  [LOCALES.SLOVENIAN]: {
    dateFormat: DATE_TIME_FORMATS.DDMMYY,
    distanceUnits: DISTANCE_UNITS.METRIC,
    mapTileLg: 'sl',
    timeFormat: DATE_TIME_FORMATS.TIME_24H,
    timeFormatWithSeconds: DATE_TIME_FORMATS.TIME_24H_SECONDS
  },
  [LOCALES.TURKISH]: {
    dateFormat: DATE_TIME_FORMATS.DDMMYY,
    distanceUnits: DISTANCE_UNITS.METRIC,
    mapTileLg: 'tr',
    timeFormat: DATE_TIME_FORMATS.TIME_24H,
    timeFormatWithSeconds: DATE_TIME_FORMATS.TIME_24H_SECONDS
  },
  [LOCALES.MACEDONIAN]: {
    dateFormat: DATE_TIME_FORMATS.DDMMYY,
    distanceUnits: DISTANCE_UNITS.METRIC,
    mapTileLg: 'mk',
    timeFormat: DATE_TIME_FORMATS.TIME_24H,
    timeFormatWithSeconds: DATE_TIME_FORMATS.TIME_24H_SECONDS
  },
  [LOCALES.ESTONIAN]: {
    dateFormat: DATE_TIME_FORMATS.DDMMYY,
    distanceUnits: DISTANCE_UNITS.METRIC,
    mapTileLg: 'et',
    timeFormat: DATE_TIME_FORMATS.TIME_24H,
    timeFormatWithSeconds: DATE_TIME_FORMATS.TIME_24H_SECONDS
  },
  [LOCALES.NORWEGIAN]: {
    dateFormat: DATE_TIME_FORMATS.DDMMYY,
    distanceUnits: DISTANCE_UNITS.METRIC,
    mapTileLg: 'no',
    timeFormat: DATE_TIME_FORMATS.TIME_24H,
    timeFormatWithSeconds: DATE_TIME_FORMATS.TIME_24H_SECONDS
  },
  [LOCALES.DUTCH]: {
    dateFormat: DATE_TIME_FORMATS.DDMMYY,
    distanceUnits: DISTANCE_UNITS.METRIC,
    mapTileLg: 'nl',
    timeFormat: DATE_TIME_FORMATS.TIME_24H,
    timeFormatWithSeconds: DATE_TIME_FORMATS.TIME_24H_SECONDS
  }
};

export const eul10n = {
  ...l10n,
  [LOCALES.ENGLISH]: {
    ...l10n[LOCALES.ENGLISH],
    dateFormat: DATE_TIME_FORMATS.DDMMYY,
    timeFormat: DATE_TIME_FORMATS.TIME_24H,
    timeFormatWithSeconds: DATE_TIME_FORMATS.TIME_24H_SECONDS
  }
};

export interface Environment {
  production: boolean;
  devTools: boolean;
  hmr: boolean;
  name: string;
  authEnv: string;
  appUrl: string;
  useSettingsApi: boolean;
  datadog: {
    applicationId: string;
    clientToken: string;
    tagEnvironment: string;
  };
  devCycle: {
    clientId: string;
  };
  here: {
    apiKeyV3: string;
  };
  googleTagManager?: {
    id: string;
    auth: string;
    environment: string;
  };
  pendo?: {
    url?: string;
    key?: string;
  };
  auth: {
    clientID: string;
    domain: string;
    audience: string;
    applicationId: string;
    useRefreshTokens: boolean;
    maxAge: number;
    connection?: string;
  };
  locationApi: {
    url: string;
    hasAssociatedDevice: boolean;
  };
  pathApiBase: {
    url: string;
  };
  geocoderApiBase: {
    url: string;
  };
  pathApiRequestPageSize: number;
  dataUpdateMessages: {
    updateInterval: number;
    idling: number;
    notIdling: number;
  };
  nearbyAssets: {
    searchRadiusMeters: number;
    assetsToReturn: number;
    searchRadiusInKm: number;
    searchRadiusInMiles: number;
  };
  liveUpdate: {
    pageSize: number;
    concurrency: number;
    pollingInterval: number;
    consecutiveFailureLimit: number;
    restartPollingDelay: number;
  };
  // zTrakBatteryAlertPct: number;
  apiRequestPageSize: number;
  datadogSite: string;
  minimumTripMS: number;
  featureFlags: {
    assetIOs: boolean;
  };
  region: string;
  vdofleet?: {
    baseApiUrl: string;
    baseApiAudience: string;
  };
  gtcxUrl?: {
    activityFeedUrl: string;
    incidentInvestigation: string;
  };
  euUrl?: {
    vdoDashboardUrl: string;
    vdoReportsUrl: string;
    geofencingUrl: string;
  };
  i18n: {
    supportedLanguages: Array<string>;
    defaultLanguage: string;
  };
  l10n: Object;
  hamburgerMenuEnabled: boolean;
  // legacyAccountsEnabled: boolean;
}
